import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FilterOptions } from "@/lib/api/leaderboard";

interface LeaderboardFiltersProps {
  filters: FilterOptions;
  onFiltersChange: (filters: FilterOptions) => void;
  agents: Array<{ id: string; name: string }>;
  companies: Array<{ id: string; name: string }>;
  isAdmin?: boolean;
}

export function LeaderboardFilters({
  filters,
  onFiltersChange,
  agents,
  companies,
  isAdmin = false,
}: LeaderboardFiltersProps) {
  return (
    <div className="flex flex-col sm:flex-row gap-4 mb-6">
      {/* Activity Type Filter */}
      <Select
        value={filters.activityType || 'all'}
        onValueChange={(value) =>
          onFiltersChange({ ...filters, activityType: value as FilterOptions['activityType'] })
        }
      >
        <SelectTrigger className="w-full sm:w-[180px]">
          <SelectValue placeholder="Activity Type" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Activities</SelectItem>
          <SelectItem value="simulations">Simulations Only</SelectItem>
          <SelectItem value="coaching">Coaching Only</SelectItem>
        </SelectContent>
      </Select>

      {/* Time Period Filter */}
      <Select
        value={filters.timePeriod || 'all'}
        onValueChange={(value) =>
          onFiltersChange({ ...filters, timePeriod: value as FilterOptions['timePeriod'] })
        }
      >
        <SelectTrigger className="w-full sm:w-[180px]">
          <SelectValue placeholder="Time Period" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Time</SelectItem>
          <SelectItem value="month">This Month</SelectItem>
          <SelectItem value="week">This Week</SelectItem>
          <SelectItem value="today">Today</SelectItem>
        </SelectContent>
      </Select>

      {/* Agent Filter */}
      <Select
        value={filters.agentId || 'all'}
        onValueChange={(value) =>
          onFiltersChange({ ...filters, agentId: value === 'all' ? undefined : value })
        }
      >
        <SelectTrigger className="w-full sm:w-[200px]">
          <SelectValue placeholder="All Agents" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Agents</SelectItem>
          {agents.map((agent) => (
            <SelectItem key={agent.id} value={agent.id}>
              {agent.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {/* Company Filter - ONLY FOR ADMINS */}
      {isAdmin && companies.length > 0 && (
        <Select
          value={filters.companyId || 'all'}
          onValueChange={(value) =>
            onFiltersChange({ ...filters, companyId: value === 'all' ? undefined : value })
          }
        >
          <SelectTrigger className="w-full sm:w-[200px]">
            <SelectValue placeholder="All Companies" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Companies</SelectItem>
            {companies.map((company) => (
              <SelectItem key={company.id} value={company.id}>
                {company.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    </div>
  );
}
